import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Row, message, Table } from 'antd';
import { COLORS } from '../theme';
import Title from 'antd/lib/typography/Title';
import { Close } from '@material-ui/icons';
import ErrorWrapper from '../../lib/error_wrapper';
import { formatMoney } from '../../lib/util';

class SourceClosingHistory extends Component {
  constructor(props) {
    super(props)

    this.source_id = this.props.source_id;

    this.state = {
      filter_query:{
        per_page:100,
        page:1
      }
    }


    this.list_history = RESTExecutor.list().config({
      label: 'closing_history',
      params:{
        ...this.state.filter_query
      }
    }).forId(this.source_id).connect(props.domains.usergroups)

    this.list_history.execute();

  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
        newData[valueKey] = value;
    }
    if (appendObj) {
        Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
        [stateKey]: newData
    }, () => {
        typeof callback === 'function' && callback()
    })
}

  render() {
    let list_history_resp=this.list_history.response();
    let rowsData=(list_history_resp.result&&list_history_resp.result.rows)||[];
    let rowsMeta=list_history_resp.meta||{}

    return (
      <div>
        <Row type='flex' style={{
          flex: 1,
          alignItems: 'center',
          paddingLeft: 20,
          paddingRight: 20,
          justifyContent: 'space-between',
          paddingTop: 20,
          paddingBottom: 6,
          borderBottom: `1px solid ${COLORS.border_basic}`
        }}>
          <Title level={2}>Source Closing History</Title>

          {typeof this.props.onClose === 'function' &&
            <div style={{
              // width: 100,
              paddingLeft: 20,
              // paddingRight: 20,
              height: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center'
            }}>
              <Close className='hand-cursor' onClick={() => {
                if (typeof this.props.onClose === 'function') {
                  this.props.onClose();
                } else {
                  message.error("Please define onClose function")
                }
              }} />
            </div>}
        </Row>
        <ErrorWrapper error={list_history_resp}
          onReload={() => {
            this.list_history.execute();
          }}>
          <Table
            className='main-table'
            size='small'
            dataSource={rowsData}
            loading={list_history_resp.fetching}
            columns={[
              {title:'created at',dataIndex:'created_at',key:'created_at'},
              {title:"Closed Date",dataIndex:'txn_date',key:'txn_date'},
              {title:"closed by",dataIndex:'username',key:'username'},
              {title:"close note",dataIndex:'close_note',key:'close_note'}
            ]}
            pagination={{
              simple: false,
              size: 'small',
              position: 'bottom',
              onChange: (current, size) => {
                  this.stateUpdater({
                    stateKey:'filter_query',
                    appendObj:{
                      per_page:size,
                      page:current
                    },
                    callback:()=>{
                      this.list_history.config({
                        params:{
                          ...this.state.filter_query
                        }
                      }).execute();
                    }
                  })
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              // defaultPageSize: 20,
              pageSize: (rowsMeta && rowsMeta.requested_count),

              total: (rowsMeta && rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
          }}

          />
        </ErrorWrapper>

      </div>
    );
  }
}

export default withDomains(SourceClosingHistory, "usergroups");
